'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.reloadHiscoreMajorResult = reloadHiscoreMajorResult;
exports.loadMoreHiscoreMajorResult = loadMoreHiscoreMajorResult;
var RELOAD_HISCORE_MAJOR_RESULT = 'hiscore/major/result/RELOAD_HISCORE_MAJOR_RESULT';
var RELOAD_HISCORE_MAJOR_RESULT_SUCCESS = 'hiscore/major/result/RELOAD_HISCORE_MAJOR_RESULT_SUCCESS';
var RELOAD_HISCORE_MAJOR_RESULT_FAIL = 'hiscore/major/result/RELOAD_HISCORE_MAJOR_RESULT_FAIL';

var LOAD_MORE_HISCORE_MAJOR_RESULT = 'hiscore/major/result/LOAD_MORE_HISCORE_MAJOR_RESULT';
var LOAD_MORE_HISCORE_MAJOR_RESULT_SUCCESS = 'hiscore/major/result/LOAD_MORE_HISCORE_MAJOR_RESULT_SUCCESS';
var LOAD_MORE_HISCORE_MAJOR_RESULT_FAIL = 'hiscore/major/result/LOAD_MORE_HISCORE_MAJOR_RESULT_FAIL';

var initState = {
    resultList: [],
    pager: {},
    loading: true,
    consultType: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case RELOAD_HISCORE_MAJOR_RESULT:
            return _extends({}, state, {
                resultList: [],
                pager: {},
                loading: true
            });
        case RELOAD_HISCORE_MAJOR_RESULT_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    resultList: [],
                    pager: null,
                    loading: false
                });
            }
            return _extends({}, state, {
                resultList: action.result.data.data,
                pager: action.result.data.pager,
                loading: false
            });
        case RELOAD_HISCORE_MAJOR_RESULT_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case LOAD_MORE_HISCORE_MAJOR_RESULT_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var res = _extends({}, state, {
                    pager: action.result.data.pager
                });
                res.resultList = res.resultList.concat(action.result.data.data);
                return res;
            }
        default:
            return state;
    }
}

function _reloadHiscoreMajorResult(query) {
    return {
        types: [RELOAD_HISCORE_MAJOR_RESULT, RELOAD_HISCORE_MAJOR_RESULT_SUCCESS, RELOAD_HISCORE_MAJOR_RESULT_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/hiscore/rank/school', query);
            }

            return promise;
        }()
    };
}

function _loadMoreHiscoreMajorResult(query, callback) {
    return {
        types: [LOAD_MORE_HISCORE_MAJOR_RESULT, LOAD_MORE_HISCORE_MAJOR_RESULT_SUCCESS, LOAD_MORE_HISCORE_MAJOR_RESULT_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/hiscore/rank/school', query);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function _createQuery(state, majorHashId) {
    var query = {
        majorHashId: majorHashId,
        page: state.pager ? state.pager.page + 1 : 1,
        size: 30
    };
    return query;
}

function reloadHiscoreMajorResult(majorHashId) {
    return function (dispatch, getState) {
        var state = getState().hiscoreMajorResult;
        state.pager = null;
        var query = _createQuery(state, majorHashId);
        dispatch(_reloadHiscoreMajorResult(query));
    };
}

function loadMoreHiscoreMajorResult(majorHashId, callback) {
    return function (dispatch, getState) {
        var state = getState().hiscoreMajorResult;
        if (state.pager && state.pager.page && state.pager.page == state.pager.totalPages) {
            return;
        }
        var query = _createQuery(state, majorHashId);
        dispatch(_loadMoreHiscoreMajorResult(query, callback));
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/hiscore/hiscoreMajorResult.js
// module id = 500
// module chunks = 0